import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { Label, FormWrapper, FormField } from 'libs/forms/styles';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { PasswordField } from 'libs/forms/views/fieldTypes/password';
import FormActionButton from 'libs/forms/views/formActionButton';

import Button from 'components/Button';

import { SocialButtons } from 'apps/signIn/views/socialButtons';

import { OrSeparator } from 'components';

import {
  CompactSignInWrapper,
  LogInButtonWrapper,
} from './compactSignInForm.styled';

const CompactSignInForm = props => {
  const { form, title, handleSignIn, handleNoAccount, handleForgotPassword } =
    props;
  return (
    <CompactSignInWrapper>
      <h1 style={{ color: 'black' }}>
        <Trans>{title}</Trans>
      </h1>
      <SocialButtons />
      <OrSeparator />

      <FormWrapper
        posting={form.posting}
        onSubmit={e => {
          e.preventDefault();
          form.prepare();
          handleSignIn();
        }}
        responsive
        maxResponsive
      >
        <FormField>
          <Label bold>
            <Trans>Username or email</Trans>
          </Label>
          <TextField
            fieldStore={form.fieldStores.get('usernameEmail')}
            responsive
          />
        </FormField>
        <FormField>
          <Label bold>
            <Trans>Password</Trans>
          </Label>
          <PasswordField
            fieldStore={form.fieldStores.get('password')}
            responsive
          />
        </FormField>

        <Button
          onClick={handleForgotPassword}
          appearance='plain'
          variant='secondary'
          size='xsmall'
          text={<Trans>Forgot your password?</Trans>}
        />

        <LogInButtonWrapper>
          <FormActionButton
            formStore={form}
            data-testid='login-now-button'
            buttonText='Log in'
            buttonTextPosting={form.conf.buttonTextPosting}
            variant='primary'
            style={{ justifyContent: 'center' }}
            marginTop='0px'
          />
        </LogInButtonWrapper>
      </FormWrapper>
      <div
        style={{
          alignSelf: 'stretch',
          textAlign: 'center',
        }}
      >
        <span>
          Not a member yet?{' '}
          <a
            href=''
            onClick={e => {
              e.preventDefault();
              handleNoAccount();
            }}
          >
            Sign up
          </a>
        </span>
      </div>
    </CompactSignInWrapper>
  );
};

CompactSignInForm.propTypes = {
  form: PropTypes.object,
  title: PropTypes.string,
  handleSignIn: PropTypes.func,
  handleNoAccount: PropTypes.func,
  handleForgotPassword: PropTypes.func,
  handleRequestInvite: PropTypes.func,
};

export default withNamespaces()(observer(CompactSignInForm));
